import { WebAppState } from '../realtime';
import type { DisplayPanelMode } from './videoCallMachine';

export type WebAppVideoPreparation = 'sms' | 'permissions';

export function getWebAppVideoPreparation(mode: DisplayPanelMode, state: WebAppState): WebAppVideoPreparation | null {
  if (mode !== 'WebAppState') return null;
  switch (state) {
    case WebAppState.None:
    case WebAppState.WebAppSmsSent:
      return 'sms';
    case WebAppState.AppOpened:
    case WebAppState.CameraPermissionRequested:
      return 'permissions';
    default:
      return null;
  }
}
